module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"edit-notify:title":"Редактирование","edit-notify:text":"Редактирование выполнено успешно","button-title":"Подтвердить распределение","cancel":"Отменить изменения"},"en":{"edit-notify:title":"Editing","edit-notify:text":"Editing completed successfully","button-title":"Confirm","cancel":"Cancel changes"}}')
  delete Component.options._Ctor
}
